import { Member } from '@contexts/member/MemberContext';
import { extractDataFromHTML } from '@utils/extractDataFromHTML';

export function getMemberFromCronos(root: HTMLElement): Member | null {
    const memberInfo = extractDataFromHTML(root)('memberInfo', null as Member | null);
    const memberId = (memberInfo && memberInfo.id) || extractDataFromHTML(root)('memberId', 0);

    return !!memberInfo
        ? {
              ...memberInfo,
              id: memberId,
          }
        : null;
}
